import { JSX } from "react";

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const DisplayCard = ({ title, value }: { title: string; value: string }): JSX.Element => (
    <div className="flex flex-col mt-5 pl-5 py-2 border border-rounded border-black/30 w-40">
        <div className="font-medium text-md">{title}</div>
        <div className="font-bold text-2xl">{value}</div>
    </div>
);

// #endregion Component

export default DisplayCard;
